"use client";

import { MagnifyingGlassIcon } from "@heroicons/react/16/solid";

export default ({ label, onSearch = () => {} }) => {
  return (
    <div>
      <div className="mt-2 grid grid-cols-1">
        <input
          id="search"
          name="search"
          type="search"
          placeholder={label}
          className="col-start-1 row-start-1 block w-full rounded-md bg-[#0e1219] dark:bg-dark-background-lighter dark:outline-dark-outline dark:outline py-1.5 pr-3 pl-10 text-white-900 sm:pl-9 outline-none"
          onChange={(e) => {
            onSearch(e.currentTarget.value);
          }}
        />
        <MagnifyingGlassIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
        />
      </div>
    </div>
  );
};
